// global store file for maintainig the states to share data between the components

import Vue from "vue";

export const store = new Vue({
  data: {
    groupDetail: {},
    enteredGID: "",
    registration: {
      iid: "",
      eml: "",
      mob: "",
    },
    userDetails: {},
    newsdetail: "",
    symptomChkResponse: {},
    isAppointment: false,
    appointmentDetail: {
      date: "",
      dateTime: "",
      location: "",
      noApptMsg: "",
      gender: "",
    },
    sessionID: "",
    deviceFCMToken: "",
    disclaimer: false,
    registrationSuccessResponse: "",
    isLogoAvailable: false,
    mintodaytime: "",
    maxtodaytime: "",
    mintodaytime12hrsFormate: "",
    maxtodaytime12hrsFormate: "",
    enableHealthSurvey: false,
    hideHealthSurvey: "",
    isLoginError: false,
    loginErrorMsg: "",
  },
  methods: {},
});
